export const GET_DEGREE_LEVELS = 'GET_DEGREE_LEVELS';
export const GET_DEGREE_LEVEL_BY_ID = 'GET_DEGREE_LEVEL_BY_ID';
export const UPDATE_DEGREE_LEVEL = 'UPDATE_DEGREE_LEVEL';
export const DELETE_DEGREE_LEVEL = 'DELETE_DEGREE_LEVEL';
export const CREATE_DEGREE_LEVEL = 'CREATE_DEGREE_LEVEL';
